// Integrations and data architecture: the routes and the sidebar rows of `wealth.platform.integrations` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.platform.integrations',
    routes: [
        {
            frontend: 'view',
            path: 'data-architecture',
            lazy: () => import('@/pages/view/data-architecture/page'),
        },
    ],
    nav: [
        {
            frontend: 'view',
            key: 'data-architecture',
            label: 'Data Architecture',
            href: '/view/data-architecture',
            icon: 'Plug',
            group: 'platform',
            order: 510,
        },
    ],
});
